import { isFeatureEnabled } from 'owa-feature-flags';
import { SearchScenarioId } from '../store/schema/SearchScenarioId';

/**
 * Helper function to return "X-Client-Flights" header value to compose with
 * server flights
 */
export function getXClientFlightsHeaderValue(scenarioId: SearchScenarioId): string {
    const flightNames: string[] = [];

    if (scenarioId == SearchScenarioId.Mail) {
        if (
            isFeatureEnabled('sea-trySuggestions') ||
            isFeatureEnabled('sea-trySuggestionsC') ||
            isFeatureEnabled('sea-trySuggestions-always') ||
            isFeatureEnabled('sea-naturalLanguage') ||
            isFeatureEnabled('sea-naturalLanguageR')
        ) {
            flightNames.push('ENABLENLWITHB2QAS_T');
        }

        if (isFeatureEnabled('sea-naturalLanguageCT')) {
            flightNames.push('ENABLENLWITHB2QAS_CT');
        }

        if (isFeatureEnabled('sea-naturalLanguageC')) {
            flightNames.push('ENABLENLWITHB2QAS_C');
        }

        if (isFeatureEnabled('sea-files-mru')) {
            flightNames.push('ZQFileSuggestionsOwa');
        }
    }

    return flightNames.length > 0 ? flightNames.join(',') : null;
}
